@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.kotlinfest._2026.components.layouts.MarkdownLayout as _dev_kotlinfest__2026_components_layouts_MarkdownLayout
import dev.kotlinfest._2026.components.layouts.PageLayout as _dev_kotlinfest__2026_components_layouts_PageLayout
import dev.kotlinfest._2026.pages.BrandLogoGuidelinesPage as _dev_kotlinfest__2026_pages_BrandLogoGuidelinesPage
import dev.kotlinfest._2026.pages.ChildcarePage as _dev_kotlinfest__2026_pages_ChildcarePage
import dev.kotlinfest._2026.pages.CodeOfConductEnPage as _dev_kotlinfest__2026_pages_CodeOfConductEnPage
import dev.kotlinfest._2026.pages.CodeOfConductPage as _dev_kotlinfest__2026_pages_CodeOfConductPage
import dev.kotlinfest._2026.pages.ContactPage as _dev_kotlinfest__2026_pages_ContactPage
import dev.kotlinfest._2026.pages.HomePage as _dev_kotlinfest__2026_pages_HomePage
import dev.kotlinfest._2026.pages.MyTimetablePage as _dev_kotlinfest__2026_pages_MyTimetablePage
import dev.kotlinfest._2026.pages.PrivacyPolicyPage as _dev_kotlinfest__2026_pages_PrivacyPolicyPage
import dev.kotlinfest._2026.pages.ScholarshipPage as _dev_kotlinfest__2026_pages_ScholarshipPage
import dev.kotlinfest._2026.pages.SessionDetailPage as _dev_kotlinfest__2026_pages_SessionDetailPage
import dev.kotlinfest._2026.pages.SharedTimetablePage as _dev_kotlinfest__2026_pages_SharedTimetablePage
import dev.kotlinfest._2026.pages.SponsorsPage as _dev_kotlinfest__2026_pages_SponsorsPage
import dev.kotlinfest._2026.pages.SponsorshipPage as _dev_kotlinfest__2026_pages_SponsorshipPage
import dev.kotlinfest._2026.pages.StaffRecruitmentPage as _dev_kotlinfest__2026_pages_StaffRecruitmentPage
import dev.kotlinfest._2026.pages.TicketPage as _dev_kotlinfest__2026_pages_TicketPage
import dev.kotlinfest._2026.pages.TimetablePage as _dev_kotlinfest__2026_pages_TimetablePage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Kotlin Fest 2026"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            parentLayoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _dev_kotlinfest__2026_components_layouts_MarkdownLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "dev.kotlinfest._2026.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _dev_kotlinfest__2026_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_HomePage()
        }
        ctx.router.register(
            "/brand-logo-guidelines",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initBrandLogoGuidelinesPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_BrandLogoGuidelinesPage()
        }
        ctx.router.register(
            "/childcare",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initChildcarePage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_ChildcarePage()
        }
        ctx.router.register(
            "/code-of-conduct",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initCodeOfConductPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_CodeOfConductPage()
        }
        ctx.router.register(
            "/code-of-conduct-en",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initCodeOfConductEnPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_CodeOfConductEnPage()
        }
        ctx.router.register(
            "/contact",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initContactPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_ContactPage()
        }
        ctx.router.register(
            "/privacy-policy",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initPrivacyPolicyPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_PrivacyPolicyPage()
        }
        ctx.router.register(
            "/scholarship",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initScholarshipPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_ScholarshipPage()
        }
        ctx.router.register(
            "/sessions/{id}",
            layoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initSessionDetailPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_SessionDetailPage(pageCtx)
        }
        ctx.router.register(
            "/sponsors",
            layoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initSponsorsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_SponsorsPage()
        }
        ctx.router.register(
            "/sponsorship",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initSponsorshipPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_SponsorshipPage()
        }
        ctx.router.register(
            "/staff-recruitment",
            layoutId = "dev.kotlinfest._2026.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initStaffRecruitmentPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_StaffRecruitmentPage()
        }
        ctx.router.register(
            "/ticket",
            layoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initTicketPage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_TicketPage()
        }
        ctx.router.register(
            "/timetable",
            layoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initTimetablePage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_TimetablePage()
        }
        ctx.router.register(
            "/timetable/me",
            layoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initTimetablePage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_MyTimetablePage()
        }
        ctx.router.register(
            "/timetable/your",
            layoutId = "dev.kotlinfest._2026.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.kotlinfest._2026.pages.initTimetablePage(ctx)
            },
        ) { pageCtx -> 
            _dev_kotlinfest__2026_pages_SharedTimetablePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("footer", dev.kotlinfest._2026.components.sections.FooterStyle)
        ctx.theme.registerStyle("footer-content", dev.kotlinfest._2026.components.sections.FooterContentStyle)
        ctx.theme.registerStyle("footer-cta", dev.kotlinfest._2026.components.sections.FooterCtaStyle)
        ctx.theme.registerStyle("footer-social-title", dev.kotlinfest._2026.components.sections.FooterSocialTitleStyle)
        ctx.theme.registerStyle("desktop-footer-body", dev.kotlinfest._2026.components.sections.DesktopFooterBodyStyle)
        ctx.theme.registerStyle("desktop-footer-details", dev.kotlinfest._2026.components.sections.DesktopFooterDetailsStyle)
        ctx.theme.registerStyle("desktop-footer-links", dev.kotlinfest._2026.components.sections.DesktopFooterLinksStyle)
        ctx.theme.registerStyle("desktop-footer-logo", dev.kotlinfest._2026.components.sections.DesktopFooterLogoStyle)
        ctx.theme.registerStyle("desktop-footer-divider", dev.kotlinfest._2026.components.sections.DesktopFooterDividerStyle)
        ctx.theme.registerStyle("mobile-footer-links", dev.kotlinfest._2026.components.sections.MobileFooterLinksStyle)
        ctx.theme.registerStyle("footer-legal", dev.kotlinfest._2026.components.sections.FooterLegalStyle)
        ctx.theme.registerStyle("nav-header", dev.kotlinfest._2026.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("header-logo", dev.kotlinfest._2026.components.sections.HeaderLogoStyle)
        ctx.theme.registerStyle("desktop-menu", dev.kotlinfest._2026.components.sections.DesktopMenuStyle)
        ctx.theme.registerStyle("mobile-icon-button", dev.kotlinfest._2026.components.sections.MobileIconButtonStyle)
        ctx.theme.registerStyle("mobile-menu-content", dev.kotlinfest._2026.components.sections.MobileMenuContentStyle)
        ctx.theme.registerStyle("mobile-primary-menu", dev.kotlinfest._2026.components.sections.MobilePrimaryMenuStyle)
        ctx.theme.registerStyle("mobile-policy-menu", dev.kotlinfest._2026.components.sections.MobilePolicyMenuStyle)
        ctx.theme.registerStyle("markdown-note-callout-type", dev.kotlinfest._2026.components.widgets.MarkdownNoteCalloutType)
        ctx.theme.registerStyle("markdown-warning-callout-type", dev.kotlinfest._2026.components.widgets.MarkdownWarningCalloutType)
        ctx.theme.registerStyle("primary-button", dev.kotlinfest._2026.components.widgets.PrimaryButtonStyle)
        ctx.theme.registerStyle("secondary-button", dev.kotlinfest._2026.components.widgets.SecondaryButtonStyle)
        ctx.theme.registerStyle("disabled-button", dev.kotlinfest._2026.components.widgets.DisabledButtonStyle)
        ctx.theme.registerStyle("text-button", dev.kotlinfest._2026.components.widgets.TextButtonStyle)
        ctx.theme.registerStyle("markdown-page-hero", dev.kotlinfest._2026.components.layouts.MarkdownPageHeroStyle)
        ctx.theme.registerStyle("markdown-page-hero-content", dev.kotlinfest._2026.components.layouts.MarkdownPageHeroContentStyle)
        ctx.theme.registerStyle("markdown-english-hero-title", dev.kotlinfest._2026.components.layouts.MarkdownEnglishHeroTitleStyle)
        ctx.theme.registerStyle("markdown-japanese-hero-title", dev.kotlinfest._2026.components.layouts.MarkdownJapaneseHeroTitleStyle)
        ctx.theme.registerStyle("markdown-hero-subtitle", dev.kotlinfest._2026.components.layouts.MarkdownHeroSubtitleStyle)
        ctx.theme.registerStyle("markdown-content-section", dev.kotlinfest._2026.components.layouts.MarkdownContentSectionStyle)
        ctx.theme.registerStyle("markdown", dev.kotlinfest._2026.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content", dev.kotlinfest._2026.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("nav-header-spacer", dev.kotlinfest._2026.components.layouts.NavHeaderSpacerStyle)
        ctx.theme.registerStyle("en-heading", dev.kotlinfest._2026.EnHeadingStyle)
        ctx.theme.registerStyle("en-section-title", dev.kotlinfest._2026.EnSectionTitleStyle)
        ctx.theme.registerStyle("accent-en-section-title", dev.kotlinfest._2026.AccentEnSectionTitleStyle)
        ctx.theme.registerStyle("jp-heading", dev.kotlinfest._2026.JpHeadingStyle)
        ctx.theme.registerStyle("body-text", dev.kotlinfest._2026.BodyTextStyle)
        ctx.theme.registerStyle("jp-detail-text", dev.kotlinfest._2026.JpDetailTextStyle)
        ctx.theme.registerStyle("en-metadata", dev.kotlinfest._2026.EnMetadataStyle)
        ctx.theme.registerStyle("content-container", dev.kotlinfest._2026.ContentContainerStyle)
        ctx.theme.registerStyle("timetable-hero", dev.kotlinfest._2026.pages.TimetableHeroStyle)
        ctx.theme.registerStyle("timetable-hero-title", dev.kotlinfest._2026.pages.TimetableHeroTitleStyle)
        ctx.theme.registerStyle("timetable-hero-sub", dev.kotlinfest._2026.pages.TimetableHeroSubStyle)
        ctx.theme.registerStyle("timetable-content", dev.kotlinfest._2026.pages.TimetableContentStyle)
        ctx.theme.registerStyle("venue-row", dev.kotlinfest._2026.pages.VenueRowStyle)
        ctx.theme.registerStyle("venue-label", dev.kotlinfest._2026.pages.VenueLabelStyle)
        ctx.theme.registerStyle("mobile-slot", dev.kotlinfest._2026.pages.MobileSlotStyle)
        ctx.theme.registerStyle("desktop-slot", dev.kotlinfest._2026.pages.DesktopSlotStyle)
        ctx.theme.registerStyle("time", dev.kotlinfest._2026.pages.TimeStyle)
        ctx.theme.registerStyle("empty-time", dev.kotlinfest._2026.pages.EmptyTimeStyle)
        ctx.theme.registerStyle("cards", dev.kotlinfest._2026.pages.CardsStyle)
        ctx.theme.registerStyle("session-card", dev.kotlinfest._2026.pages.SessionCardStyle)
        ctx.theme.registerStyle("session-time", dev.kotlinfest._2026.pages.SessionTimeStyle)
        ctx.theme.registerStyle("session-title", dev.kotlinfest._2026.pages.SessionTitleStyle)
        ctx.theme.registerStyle("track-title", dev.kotlinfest._2026.pages.TrackTitleStyle)
        ctx.theme.registerStyle("speaker", dev.kotlinfest._2026.pages.SpeakerStyle)
        ctx.theme.registerStyle("tag", dev.kotlinfest._2026.pages.TagStyle)
        ctx.theme.registerStyle("mobile-venue", dev.kotlinfest._2026.pages.MobileVenueStyle)
        ctx.theme.registerStyle("timetable-actions", dev.kotlinfest._2026.pages.TimetableActionsStyle)
        ctx.theme.registerStyle("my-timetable-link", dev.kotlinfest._2026.pages.MyTimetableLinkStyle)
        ctx.theme.registerStyle("timetable-toggle", dev.kotlinfest._2026.pages.TimetableToggleStyle)
        ctx.theme.registerStyle("my-timetable-intro", dev.kotlinfest._2026.pages.MyTimetableIntroStyle)
        ctx.theme.registerStyle("empty-my-timetable", dev.kotlinfest._2026.pages.EmptyMyTimetableStyle)
        ctx.theme.registerStyle("share-actions", dev.kotlinfest._2026.pages.ShareActionsStyle)
        ctx.theme.registerStyle("share-qr", dev.kotlinfest._2026.pages.ShareQrStyle)
        ctx.theme.registerStyle("notification-notice", dev.kotlinfest._2026.pages.NotificationNoticeStyle)
        ctx.theme.registerStyle("guide-overlay", dev.kotlinfest._2026.pages.GuideOverlayStyle)
        ctx.theme.registerStyle("guide-dialog", dev.kotlinfest._2026.pages.GuideDialogStyle)
        ctx.theme.registerStyle("guide-title", dev.kotlinfest._2026.pages.GuideTitleStyle)
        ctx.theme.registerStyle("guide-step", dev.kotlinfest._2026.pages.GuideStepStyle)
        ctx.theme.registerStyle("guide-step-number", dev.kotlinfest._2026.pages.GuideStepNumberStyle)
        ctx.theme.registerStyle("guide-text", dev.kotlinfest._2026.pages.GuideTextStyle)
        ctx.theme.registerStyle("ticket-hero", dev.kotlinfest._2026.pages.TicketHeroStyle)
        ctx.theme.registerStyle("ticket-hero-title", dev.kotlinfest._2026.pages.TicketHeroTitleStyle)
        ctx.theme.registerStyle("ticket-hero-sub-title", dev.kotlinfest._2026.pages.TicketHeroSubTitleStyle)
        ctx.theme.registerStyle("ticket-content", dev.kotlinfest._2026.pages.TicketContentStyle)
        ctx.theme.registerStyle("ticket-intro", dev.kotlinfest._2026.pages.TicketIntroStyle)
        ctx.theme.registerStyle("ticket-grid", dev.kotlinfest._2026.pages.TicketGridStyle)
        ctx.theme.registerStyle("ticket-card", dev.kotlinfest._2026.pages.TicketCardStyle)
        ctx.theme.registerStyle("student-ticket-card", dev.kotlinfest._2026.pages.StudentTicketCardStyle)
        ctx.theme.registerStyle("ticket-tag", dev.kotlinfest._2026.pages.TicketTagStyle)
        ctx.theme.registerStyle("sold-out-ticket-tag", dev.kotlinfest._2026.pages.SoldOutTicketTagStyle)
        ctx.theme.registerStyle("ticket-title", dev.kotlinfest._2026.pages.TicketTitleStyle)
        ctx.theme.registerStyle("sold-out-ticket-card", dev.kotlinfest._2026.pages.SoldOutTicketCardStyle)
        ctx.theme.registerStyle("sold-out-ticket-title", dev.kotlinfest._2026.pages.SoldOutTicketTitleStyle)
        ctx.theme.registerStyle("ticket-description", dev.kotlinfest._2026.pages.TicketDescriptionStyle)
        ctx.theme.registerStyle("ticket-deadline", dev.kotlinfest._2026.pages.TicketDeadlineStyle)
        ctx.theme.registerStyle("ticket-card-footer", dev.kotlinfest._2026.pages.TicketCardFooterStyle)
        ctx.theme.registerStyle("ticket-price", dev.kotlinfest._2026.pages.TicketPriceStyle)
        ctx.theme.registerStyle("student-price-label", dev.kotlinfest._2026.pages.StudentPriceLabelStyle)
        ctx.theme.registerStyle("ticket-text-section", dev.kotlinfest._2026.pages.TicketTextSectionStyle)
        ctx.theme.registerStyle("ticket-section-title", dev.kotlinfest._2026.pages.TicketSectionTitleStyle)
        ctx.theme.registerStyle("ticket-legal-text", dev.kotlinfest._2026.pages.TicketLegalTextStyle)
        ctx.theme.registerStyle("hero", dev.kotlinfest._2026.pages.HeroStyle)
        ctx.theme.registerStyle("hero-main", dev.kotlinfest._2026.pages.HeroMainStyle)
        ctx.theme.registerStyle("hero-logo", dev.kotlinfest._2026.pages.HeroLogoStyle)
        ctx.theme.registerStyle("event-date", dev.kotlinfest._2026.pages.EventDateStyle)
        ctx.theme.registerStyle("venue", dev.kotlinfest._2026.pages.VenueStyle)
        ctx.theme.registerStyle("hero-button-grid", dev.kotlinfest._2026.pages.HeroButtonGridStyle)
        ctx.theme.registerStyle("follow", dev.kotlinfest._2026.pages.FollowStyle)
        ctx.theme.registerStyle("follow-copy", dev.kotlinfest._2026.pages.FollowCopyStyle)
        ctx.theme.registerStyle("follow-title-frame", dev.kotlinfest._2026.pages.FollowTitleFrameStyle)
        ctx.theme.registerStyle("follow-title-image", dev.kotlinfest._2026.pages.FollowTitleImageStyle)
        ctx.theme.registerStyle("concept", dev.kotlinfest._2026.pages.ConceptStyle)
        ctx.theme.registerStyle("concept-content", dev.kotlinfest._2026.pages.ConceptContentStyle)
        ctx.theme.registerStyle("concept-heading", dev.kotlinfest._2026.pages.ConceptHeadingStyle)
        ctx.theme.registerStyle("concept-title", dev.kotlinfest._2026.pages.ConceptTitleStyle)
        ctx.theme.registerStyle("concept-lead", dev.kotlinfest._2026.pages.ConceptLeadStyle)
        ctx.theme.registerStyle("news-section", dev.kotlinfest._2026.pages.NewsSectionStyle)
        ctx.theme.registerStyle("news-list", dev.kotlinfest._2026.pages.NewsListStyle)
        ctx.theme.registerStyle("news-row", dev.kotlinfest._2026.pages.NewsRowStyle)
        ctx.theme.registerStyle("news-date", dev.kotlinfest._2026.pages.NewsDateStyle)
        ctx.theme.registerStyle("news-entry-accent", dev.kotlinfest._2026.pages.NewsEntryAccentStyle)
        ctx.theme.registerStyle("news-entry-interactive", dev.kotlinfest._2026.pages.NewsEntryInteractiveStyle)
        ctx.theme.registerStyle("photo-grid", dev.kotlinfest._2026.pages.PhotoGridStyle)
        ctx.theme.registerStyle("overview", dev.kotlinfest._2026.pages.OverviewStyle)
        ctx.theme.registerStyle("overview-card", dev.kotlinfest._2026.pages.OverviewCardStyle)
        ctx.theme.registerStyle("overview-row", dev.kotlinfest._2026.pages.OverviewRowStyle)
        ctx.theme.registerStyle("sponsor-grid", dev.kotlinfest._2026.pages.SponsorGridStyle)
        ctx.theme.registerStyle("kotori-sponsor-grid", dev.kotlinfest._2026.pages.KotoriSponsorGridStyle)
        ctx.theme.registerStyle("gold-sponsor-grid", dev.kotlinfest._2026.pages.GoldSponsorGridStyle)
        ctx.theme.registerStyle("silver-sponsor-grid", dev.kotlinfest._2026.pages.SilverSponsorGridStyle)
        ctx.theme.registerStyle("sponsor-card", dev.kotlinfest._2026.pages.SponsorCardStyle)
        ctx.theme.registerStyle("sponsor-logo-box", dev.kotlinfest._2026.pages.SponsorLogoBoxStyle)
        ctx.theme.registerStyle("gold-sponsor-logo-box", dev.kotlinfest._2026.pages.GoldSponsorLogoBoxStyle)
        ctx.theme.registerStyle("silver-sponsor-logo-box", dev.kotlinfest._2026.pages.SilverSponsorLogoBoxStyle)
        ctx.theme.registerStyle("sponsors", dev.kotlinfest._2026.pages.SponsorsStyle)
        ctx.theme.registerStyle("sponsors-content", dev.kotlinfest._2026.pages.SponsorsContentStyle)
        ctx.theme.registerStyle("home-sponsors", dev.kotlinfest._2026.pages.HomeSponsorsStyle)
        ctx.theme.registerStyle("home-sponsors-content", dev.kotlinfest._2026.pages.HomeSponsorsContentStyle)
        ctx.theme.registerStyle("sponsor-intro", dev.kotlinfest._2026.pages.SponsorIntroStyle)
        ctx.theme.registerStyle("kotori-sponsor-name", dev.kotlinfest._2026.pages.KotoriSponsorNameStyle)
        ctx.theme.registerStyle("compact-sponsor-name", dev.kotlinfest._2026.pages.CompactSponsorNameStyle)
        ctx.theme.registerStyle("session-header-backdrop", dev.kotlinfest._2026.pages.SessionHeaderBackdropStyle)
        ctx.theme.registerStyle("session-detail-content", dev.kotlinfest._2026.pages.SessionDetailContentStyle)
        ctx.theme.registerStyle("session-lead", dev.kotlinfest._2026.pages.SessionLeadStyle)
        ctx.theme.registerStyle("session-meta", dev.kotlinfest._2026.pages.SessionMetaStyle)
        ctx.theme.registerStyle("session-detail-title", dev.kotlinfest._2026.pages.SessionDetailTitleStyle)
        ctx.theme.registerStyle("speaker-profile", dev.kotlinfest._2026.pages.SpeakerProfileStyle)
        ctx.theme.registerStyle("speaker-avatar", dev.kotlinfest._2026.pages.SpeakerAvatarStyle)
        ctx.theme.registerStyle("speaker-name", dev.kotlinfest._2026.pages.SpeakerNameStyle)
        ctx.theme.registerStyle("speaker-account", dev.kotlinfest._2026.pages.SpeakerAccountStyle)
        ctx.theme.registerStyle("session-description", dev.kotlinfest._2026.pages.SessionDescriptionStyle)
        ctx.theme.registerStyle("related-section", dev.kotlinfest._2026.pages.RelatedSectionStyle)
        ctx.theme.registerStyle("desktop-only-related", dev.kotlinfest._2026.pages.DesktopOnlyRelatedStyle)
        ctx.theme.registerStyle("related-heading", dev.kotlinfest._2026.pages.RelatedHeadingStyle)
        ctx.theme.registerStyle("related-card", dev.kotlinfest._2026.pages.RelatedCardStyle)
        ctx.theme.registerStyle("related-title", dev.kotlinfest._2026.pages.RelatedTitleStyle)
        ctx.theme.registerStyle("empty-related", dev.kotlinfest._2026.pages.EmptyRelatedStyle)
        ctx.theme.registerVariant("-markdown", dev.kotlinfest._2026.components.widgets.MarkdownCalloutVariant
        )
        ctx.theme.registerVariant("-circle", dev.kotlinfest._2026.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", dev.kotlinfest._2026.UncoloredButtonVariant
        )
        dev.kotlinfest._2026.initTheme(ctx)
        dev.kotlinfest._2026.initColorMode(ctx)
        dev.kotlinfest._2026.initSiteStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.kotlinfest._2026.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
